const fs = require('fs');
const path = require('path');

const NON_COMPONENT_FOLDER = [
  'internal',
  'TPAComponentsConfig',
  'Pimple',
  'WSR',
];

const matches = (haystack) => (needle) => haystack.some((h) => needle === h);

const componentNameInvalidators = [
  (fileName) => /^\./.test(fileName), // skip hidden folders, if any (like .DS_STORE)
  path.extname,
  matches(NON_COMPONENT_FOLDER),
];

const listAllComponents = ({ currentWorkingDirectory }) =>
  fs
    .readdirSync(currentWorkingDirectory)
    .filter((file) => !componentNameInvalidators.some((v) => v(file)));

const currentWorkingDirectory = path.resolve(__dirname, '../', 'components');
const componentsList = listAllComponents({
  currentWorkingDirectory,
});

const allComponents = componentsList.reduce(
  (listOfComponents, currentComponent) => {
    const ref = require(path.resolve(
      currentWorkingDirectory,
      currentComponent,
    ));
    listOfComponents[currentComponent] = ref[currentComponent];

    return listOfComponents;
  },
  {},
);

module.exports = allComponents;
